<template>
    <div v-if="modal" class="modal-container modal-container--scrollable">
        <div class="modal-wrapper">
            <div class="modal submission-modal">
                <button class="modal__close" @click="closeModal">
                    <svg x="0px" y="0px" viewBox="0 0 24 24" fill="currentColor">
                        <polygon class="st0" points="24,1.6 22.6,0.2 12.1,10.7 1.4,0 0,1.4 10.7,12.1 0.3,22.6 1.7,24 12.1,13.6 22.4,23.9 23.9,22.5 13.5,12.1 " />
                    </svg>
                </button>
                <div class="submission-modal__box">
                    <div v-if="type === 'code'">
                        <img src="/images/sub/inquiry/popup-image-code.jpg" alt="" />
                    </div>
                    <div v-if="type === 'model'">
                        <img src="/images/sub/inquiry/popup-image-model.jpg" alt="" />
                    </div>
                    <div v-if="type === 'privacy'" class="inquiry">
                        <div class="inner">{{ submissionInputsAgreement }}</div>
                    </div>
                    <div v-if="message" class="message">
                        <div class="inner">
                            <span v-html="message"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import submissionInputsAgreement from "./submission-inputs-agreement";

export default {
    data() {
        return {
            modal: false,
            type: "",
            message: undefined,
            submissionInputsAgreement,
        };
    },
    methods: {
        openModal(type) {
            event.preventDefault();
            document.querySelector("html").setAttribute("data-modal", "opened");
            this.modal = true;
            this.type = type;
        },
        closeModal() {
            document.querySelector("html").removeAttribute("data-modal");
            this.modal = false;
        },
        openModalWithMessage(message) {
            event.preventDefault();
            document.querySelector("html").setAttribute("data-modal", "opened");
            this.modal = true;
            this.message = message;
        },
    },
};
</script>
<style lang="scss" scoped>
.submission-modal {
    max-width: none;
    width: auto;
    img {
        display: block;
    }
    .inquiry {
        max-width: 600px;
        width: 100%;
        line-height: 1.4;
        font-size: 14px;
    }
    .inner {
        padding: 34px;
        white-space: pre-wrap;
    }
}
@media (max-width: 1200px) {
    .submission-modal {
        .inquiry {
            font-size: 13px;
        }
        .message {
            font-size: 14px;
        }
        .inner {
            padding: 24px;
        }
    }
}
</style>
